<template>
  <div v-if="npsDatas.nps_overall" id="feedback">
    <div v-if="isLoading" class="loading">
      &nbsp;
    </div>

    <div
      v-if="npsDatas.nps_overall.overall_four_weeks_count > 1"
      class="dashboard-body"
    >
      <DashboardTitleSearch
        :property-name="npsDatas.nps_overall.property_name"
        :property-id="property_id"
      />
      <div class="full-box-no-padding">
        <div style="width:100%;align:right">
          <!-- <form @submit.prevent="filterDate">
            <button
              type="submit"
              style="float:right;"
              class="button button-300-small-padding"
            >
              {{ filterDateStart }} - {{ filterDateEnd }}
            </button>
          </form> -->
        </div>
      </div>
      <div v-if="filterShow" class="full-box">
        <div
          style="width:400px;float:right;z-index:1000;position:absolute;right:20px;background-color:#FFFFFF;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);border-radius:4px"
        >
          <date-range-picker
            :width="'400'"
            :from="filterDateStart"
            :to="filterDateEnd"
            :panel="$route.query.panel"
            @update="updateDateRange"
          />
        </div>
      </div>
      <div class="full-box">
        <h2 class="bold">STATS</h2>
        <div>
          <div class="dashboard-box-horizontal gauge-chart">
            <span class="box-header">Experience Score</span>
            <gauge
              :svgStyle="{ maxHeight: '162px', padding: '2px 16px' }"
              :min="-100"
              :max="100"
              :value="npsDatas.nps_overall.sentiment_score_four_weeks_overall"
              :thickness="30"
              :minThreshold="-11"
              :maxThreshold="49"
              :pointerStrokeWidth="8"
              :pivotRadius="10"
              :pointerGap="3"
              :padding="false"
              minThresholdFill="#de4c40"
              maxThresholdFill="#00a660"
              activeFill="#e5e5e5"
              inactiveFill="#e5e5e5"
            />
            <span class="box-footer"
              >{{ npsDatas.nps_overall.sentiment_score_diff }}% change past 6
              weeks</span
            >
            <!-- <span class="box-number">{{ npsDatas.nps_overall.sentiment_score_four_weeks_overall }}</span>
            <span class="box-header">Recent Experience Score</span>
            <span class="box-footer">{{ npsDatas.nps_overall.sentiment_score_diff }}% change past 4 weeks</span> -->
          </div>
          <div class="dashboard-box-horizontal gauge-chart">
            <span class="box-header">% Positive Sentiment</span>
            <gauge
              :svgStyle="{ maxHeight: '162px', padding: '2px 16px' }"
              :min="0"
              :max="100"
              :value="
                (npsDatas.nps_overall.sentiment_score_four_weeks_positive /
                  npsDatas.nps_overall.overall_four_weeks_count) *
                  100
              "
              :thickness="30"
              :pointerStrokeWidth="8"
              :pivotRadius="10"
              :pointerGap="3"
              :padding="false"
              unit="%"
              activeFill="#00a660"
              inactiveFill="#e5e5e5"
            />
            <span class="box-footer">past 6 weeks</span>
            <!-- <span class="box-number">{{ (npsDatas.nps_overall.nps_classic_four_weeks_positive / npsDatas.nps_overall.overall_four_weeks_count * 100).toFixed(1) }}%</span>
            <span class="box-header">Positive Sentiment</span>
            <span class="box-footer">past 6 weeks</span> -->
          </div>
          <div class="dashboard-box-horizontal gauge-chart">
            <span class="box-header">NPS Score</span>
            <gauge
              :svgStyle="{ maxHeight: '162px', padding: '2px 16px' }"
              :min="-100"
              :max="100"
              :value="npsDatas.nps_overall.nps_classic_four_weeks_overall"
              :thickness="30"
              :minThreshold="-11"
              :maxThreshold="49"
              :pointerStrokeWidth="8"
              :pivotRadius="10"
              :pointerGap="3"
              :padding="false"
              minThresholdFill="#de4c40"
              maxThresholdFill="#00a660"
              activeFill="#e5e5e5"
              inactiveFill="#e5e5e5"
            />
            <span class="box-footer"
              >{{ npsDatas.nps_overall.nps_classic_diff }}% change past 6
              weeks</span
            >
          </div>
          <div class="dashboard-box-horizontal gauge-chart">
            <span class="box-header">% Helpful Feedback</span>
            <gauge
              :svgStyle="{ maxHeight: '162px', padding: '2px 16px' }"
              :min="0"
              :max="100"
              :value="
                (
                  npsDatas.nps_overall.total_feedback /
                  npsDatas.nps_overall.total_feedback_imported
                ).toFixed(2) * 100
              "
              :thickness="30"
              :pointerStrokeWidth="8"
              :pivotRadius="10"
              :pointerGap="3"
              :padding="false"
              unit="%"
              activeFill="#00a660"
              inactiveFill="#e5e5e5"
            />
            <span class="box-footer">&nbsp;</span>
          </div>
          <div class="dashboard-box-horizontal three-rows">
            <span class="box-number">{{
              npsDatas.nps_overall.total_feedback
            }}</span>
            <span class="box-header"
              >Total Helpful <br />
              Feedback</span
            >
            <span class="box-footer"
              >{{ npsDatas.nps_overall.total_feedback_imported }} Analyzed
            </span>
          </div>
        </div>
      </div>

      <div class="full-box">
        <div v-if="actions.data">
          <h2 class="bold">STRATEGIC ACTIONS REQUIRED</h2>
          <div v-if="actions.data" class="action-boxes">
            <div
              v-for="(action, index) in actions.data.slice(0, 4)"
              :key="action.id"
              class="action-box"
            >
              <div class="number-box-left">
                <span class="big-digits-number-red">{{ index + 1 }}</span>
                <br />
              </div>
              <div class="action-body">
                <div v-if="action.nps <= -11" class="sentiment-icons">
                  <img src="../assets/mad.png" />
                </div>
                <div
                  v-else-if="action.nps > -11 && action.nps < 50"
                  class="sentiment-icons"
                >
                  <img src="../assets/neutral.png" />
                </div>
                <div v-else-if="action.nps >= 50" class="sentiment-icons">
                  <img src="../assets/happy.png" />
                </div>
                <div class="box-header-small-line">
                  {{ action.action_name }}
                </div>
                <div v-if="npsCategories.data">
                  <b
                    >{{
                      Math.round(
                        (npsCategories.data[index].action_score /
                          npsCategories.action_score_total) *
                          100
                      )
                    }}%</b
                  >
                  of overall customer statisfaction is impacted by
                  <b>{{ npsCategories.data[index].name }}</b>
                </div>

                <div class="action-ngrams-body">
                  <div class="action-title">Top Customer Themes:</div>
                  <div
                    v-for="(ngram, index) in action.ngrams"
                    :key="ngram.word_id"
                    :class="[
                      'action-ngrams-box',
                      getSentimentFontColorClass(ngram.mcss)
                    ]"
                  >
                    <router-link
                      :to="{
                        name: 'dashboardFeedbackByCategoryByWords',
                        params: {
                          id: property_id,
                          cat_id: action.category_id,
                          word_id: ngram.word_id,
                          cat_name: action.category_name
                        }
                      }"
                    >
                      {{ index + 1 }}. <i>"{{ ngram.words }}"</i>
                    </router-link>
                  </div>
                </div>
                <div class="box-footer">
                  <router-link
                    :to="{
                      name: 'dashboardFeedbackByCategory',
                      params: { id: property_id, cat_id: action.category_id }
                    }"
                    class="button button-150"
                  >
                    More Analysis
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="npsCategories.data" class="full-box">
        <h2 class="bold">
          CUSTOMER SATISFACTION PRIORITY RANKINGS
          <span v-if="npsCategories.data.length > 4">
            <span v-if="numberOfCategoriesToShow <= 4">
              <a
                href=""
                class="small-text"
                @click.prevent="showAllCategories()"
              >
                (Show More)
              </a>
            </span>
            <span v-else>
              <a
                href=""
                class="small-text"
                @click.prevent="setNumberOfCategoriesToShow(4)"
              >
                (Show Less)
              </a>
            </span>
          </span>
        </h2>
        <div v-if="npsCategories.data">
          <div
            v-for="(category, index) in npsCategories.data.slice(
              0,
              numberOfCategoriesToShow
            )"
            :key="category.id"
            :class="[
              'dashboard-centered-box',
              getSentimentClass(category.four_weeks_nps_score)
            ]"
          >
            <div class="number-box-left">
              <span class="big-digits-number-black">{{ index + 1 }}</span
              ><br />
            </div>
            <div class="emoji-box-right">
              <div
                v-if="category.four_weeks_nps_score <= -11"
                class="emoji-icons"
              >
                <img src="../assets/mad.png" />
              </div>
              <div
                v-else-if="
                  category.four_weeks_nps_score > -11 &&
                    category.four_weeks_nps_score < 49
                "
                class="emoji-icons"
              >
                <img src="../assets/neutral.png" />
              </div>
              <div
                v-else-if="category.four_weeks_nps_score > 49"
                class="emoji-icons"
              >
                <img src="../assets/happy.png" />
              </div>
            </div>
            <div class="box-header-small-line category-body">
              <span class="box-header box-link">
                <router-link
                  :to="{
                    name: 'dashboardFeedbackByCategory',
                    params: { id: property_id, cat_id: category.id }
                  }"
                >
                  {{ category.name }}
                </router-link>
              </span>
              <span class="box-number"
                >{{
                  Math.round(
                    (category.action_score / npsCategories.action_score_total) *
                      100
                  )
                }}%</span
              >
              <span class="box-number-label">Satisfaction Impact</span><br />
              <span class="box-number">{{
                category.four_weeks_nps_score
              }}</span>
              <span class="box-number-label">Recent Experience Score</span>
            </div>
          </div>
        </div>
      </div>

      <div class="full-box">
        <h2 class="bold">CATEGORY EXPERIENCE TRENDS</h2>
        <apexchart
          ref="categoryExperienceAreaGraph"
          type="area"
          height="500"
          :options="categoryExperienceAreaGraphOptions"
          :series="categoryExperienceAreaGraphSeries"
        ></apexchart>
      </div>

      <div class="full-box">
        <h2 class="bold">MOST COMMON CUSTOMER PHRASES</h2>
        <div class="word-cloud">
          <vue-word-cloud
            style="
              height: 450px;
              width: 100%;
            "
            :words="wordcloud.data"
            :color="
              ([, weight, sentiment]) =>
                sentiment > 49
                  ? '#00a660'
                  : sentiment > -11
                  ? '#FFC73F'
                  : '#7e7e7e'
            "
            :spacing="0.8"
            :animation-duration="5"
            :animation-overlap="5"
            animation-easing="ease-in-out"
            font-family="Merienda"
          >
            <template v-slot="props">
              <div style="cursor: pointer;" @click="onWordClick(props.text)">
                {{ props.text }}
              </div>
            </template>
          </vue-word-cloud>
        </div>
      </div>

      <div class="full-box">
        <h2 class="bold">CATEGORY COMMENT FREQUENCY</h2>
        <apexchart
          ref="treemapCategoryFrequency"
          width="100%"
          type="treemap"
          :options="treemapCategoryFrequencyOptions"
          :series="treemapCategoryFrequencySeries"
        >
        </apexchart>
      </div>

      <div class="full-box">
        <div class="dashboard-graph-line center">
          <h2 class="bold">RECENT EXPERIENCE SCORE TREND</h2>
          <div style="padding: 5px;">
            <apexchart
              type="area"
              height="350"
              :options="sentimentLineChartOptions"
              :series="sentimentLineChartSeries"
            ></apexchart>
          </div>
        </div>
        <div class="dashboard-graph-doughnut center">
          <div>
            <h2 class="bold">RECENT EXPERIENCE SENTIMENT ANALYSIS</h2>
          </div>
          <div class="pie-chart">
            <apexchart
              type="pie"
              :options="pieOptions"
              :series="pieExperienceSeries"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="full-box">
        <div class="dashboard-graph-line center">
          <h2 class="bold">NET PROMOTER SCORE TRENDS</h2>
          <div style="padding: 5px;">
            <apexchart
              type="area"
              height="349"
              :options="npsLineChartOptions"
              :series="npsLineChartSeries"
            ></apexchart>
          </div>
        </div>
        <div class="dashboard-graph-doughnut center">
          <h2 class="bold">NPS SENTIMENT ANALYSIS</h2>
          <div class="pie-chart">
            <apexchart
              ref="classicNPSPieChart"
              type="pie"
              :options="pieOptions"
              :series="pieNPSSeries"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTitleSearch from "@/components/DashboardTitleSearch";
import api from "@/api/index";
import VueWordCloud from "vuewordcloud";
import router from "@/router";

const apiService = new api.APIServiceFeedbackDashboard();
const apiServiceFeedback = new api.APIServiceFeedback();

export default {
  name: "DashboardFeedback",
  components: {
    DashboardTitleSearch,
    [VueWordCloud.name]: VueWordCloud
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    }
  },
  data() {
    return {
      isLoading: true,
      filterShow: false,
      npsDatas: {},
      npsCategories: {},
      actions: [],
      page: 1,
      per_page: 25,
      total_items: 0,
      total_pages: 0,
      numberOfCategoriesToShow: 18,
      property_id: parseInt(this.$route.params.id),
      searchKeywords: "",
      filterDateStart: "01/01/2023",
      filterDateEnd: "03/31/2023",
      wordcloud: [],
      pieOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "pie"
        },
        legend: {
          position: "top"
        },
        labels: ["Positive", "Neutral", "Negative"],
        colors: ["#00a660", "#cfd1d3", "#de4c40"]
      },
      pieExperienceSeries: [44, 55, 13],
      pieNPSSeries: [44, 55, 13],
      treemapCategoryFrequencyOptions: {},
      treemapCategoryFrequencySeries: [
        {
          data: [
            {
              x: "none",
              y: 0
            }
          ]
        }
      ],
      sentimentLineChartOptions: {},
      sentimentLineChartSeries: [],
      npsLineChartOptions: {},
      npsLineChartSeries: [],
      categoryExperienceAreaGraphOptions: {
        chart: {
          id: "vuechart-example2",
          type: "area",
          stacked: false,
          zoom: {
            enabled: false
          }
        },
        xaxis: {
          type: "datetime",
          tickAmount: 8,
          labels: {
            rotate: -15,
            rotateAlways: true
            // formatter: function(val, timestamp) {
            //   return moment(new Date(timestamp)).format("DD MMM YYYY")
            // }
          }
        },
        dataLabels: {
          enabled: false
        },
        yaxis: {
          min: -100,
          max: 100
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: -10
        },
        title: {
          text: "by week",
          align: "left",
          offsetX: 14
        }
      },
      categoryExperienceAreaGraphSeries: []
    };
  },
  created() {
    this.isLoading = true;
    this.resetData();
    this.getPropertyFeedbackAction();
    this.getPropertyFeedbackNPS();
    this.getPropertyFeedbackCategoryNPS();
    this.getPropertyFeedbackNPSWeekly();
    this.getPropertyWordCloud();
    this.getPropertyFeedbackCategoryFrequencyGraph();
    this.getPropertyFeedbackCategoryAllNPSWeekly();
  },
  methods: {
    filterDate: function() {
      console.log("showhide date");
      this.filterShow = !this.filterShow;
    },
    updateDateRange: function() {
      console.log("update date range");
      this.filterShow = false;
    },
    getPropertyFeedbackNPS: function() {
      apiService.getPropertyFeedbackNPS(this.$route.params.id).then(data => {
        this.npsDatas = data;
        this.pieNPSSeries = [
          data.nps_overall.nps_classic_four_weeks_positive,
          data.nps_overall.nps_classic_four_weeks_neutral,
          data.nps_overall.nps_classic_four_weeks_negative
        ];
        this.pieExperienceSeries = [
          data.nps_overall.sentiment_score_four_weeks_positive,
          data.nps_overall.sentiment_score_four_weeks_neutral,
          data.nps_overall.sentiment_score_four_weeks_negative
        ];
        this.$store.commit("setProperty", {
          id: this.property_id,
          name: data.nps_overall.property_name
        });
      });
    },
    getPropertyFeedbackCategoryFrequencyGraph: function() {
      apiService
        .getPropertyFeedbackCategoryFrequencyGraph(this.$route.params.id)
        .then(data => {
          var percentage_to_show = 0.02;
          console.log(data);
          this.treemapCategoryFrequencySeries = [
            {
              data: data.data
            }
          ];
          this.treemapCategoryFrequencyOptions = {
            chart: {
              height: 550,
              events: {
                click: function(event, chartContext, config) {
                  // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                  console.log(config);
                  router.push({
                    name: "dashboardFeedbackByCategory",
                    params: {
                      cat_id: data.data[config.dataPointIndex].id,
                      cat_name: data.data[config.seriesIndex].x
                    }
                  });
                }
              }
            },
            dataLabels: {
              enabled: true,
              style: {
                fontSize: "14px"
              },
              formatter: function(text, op) {
                if (op.value / data.total_feedback_count > percentage_to_show) {
                  return [text, op.value];
                } else {
                  return [];
                }
              },
              offsetY: -4
            },
            plotOptions: {
              treemap: {
                distributed: true,
                enableShades: false
              }
            }
          };
          window.dispatchEvent(new Event("resize"));
        });
    },
    onWordClick: function(theword) {
      console.log("clicked");
    },
    getRecentCount: function() {
      return this.npsDatas.nps_overall.overall_four_weeks_count;
    },
    getPropertyFeedbackNPSWeekly: function() {
      apiService
        .getPropertyFeedbackNPSWeekly(this.$route.params.id)
        .then(data => {
          this.sentimentLineChartOptions = {
            chart: {
              type: "area",
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "smooth"
            },
            yaxis: {
              min: -100,
              max: 100
            },
            grid: {
              row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5
              }
            },
            xaxis: {
              labels: {
                rotate: -45
              },
              tickPlacement: "on",
              categories: data.nps_week_num
            }
          };
          this.sentimentLineChartSeries = [
            {
              name: "Experience Score",
              data: data.machinecore_nps_week_value_list
            }
          ];
          this.npsLineChartOptions = {
            chart: {
              type: "area",
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "smooth"
            },
            yaxis: {
              min: -100,
              max: 100
            },
            grid: {
              row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5
              }
            },
            xaxis: {
              labels: {
                rotate: -45
              },
              tickPlacement: "on",
              categories: data.nps_week_num
            }
          };
          this.npsLineChartSeries = [
            {
              name: "NPS Score",
              data: data.nps_week_value
            }
          ];
        });
    },
    getPropertyFeedbackCategoryAllNPSWeekly: function() {
      apiService
        .getPropertyFeedbackCategoryAllNPSWeekly(this.$route.params.id)
        .then(data => {
          this.$refs.categoryExperienceAreaGraph.updateOptions({
            series: data.category
          });
          for (var i = 0; i < data.category.length; i++) {
            if (i > 3) {
              this.$refs.categoryExperienceAreaGraph.hideSeries(
                data.category[i].name
              );
            }
          }
        });
    },
    getPropertyFeedbackAction: function() {
      apiService.getPropertyFeedbackAction(this.$route.params.id).then(data => {
        this.actions = data;
        this.isLoading = false;
      });
    },
    getPropertyFeedbackCategoryNPS: function() {
      apiService
        .getPropertyFeedbackCategoryNPS(this.$route.params.id)
        .then(data => {
          this.npsCategories = data;
          console.log(this.npsCategories);
        });
    },
    getPropertyWordCloud: function() {
      apiService
        .getPropertyWordCloudAllgram(this.$route.params.id)
        .then(data => {
          this.wordcloud = data;
        });
    },
    pageBack: function() {
      this.page = this.page - 1;
      this.getPropertyFeedback();
    },
    pageNext: function() {
      this.page = this.page + 1;
      this.getPropertyFeedback();
    },
    reloadFeedback: function() {
      this.getPropertyFeedback();
    },
    showAllCategories: function() {
      this.numberOfCategoriesToShow = this.npsCategories.length;
    },
    setNumberOfCategoriesToShow: function(number) {
      this.numberOfCategoriesToShow = number;
    },
    deleteFeedback: function(feedbackID) {
      apiServiceFeedback.deleteFeedback(feedbackID).then(data => {});
      this.hide();
      setTimeout(() => {
        this.reloadFeedback();
      }, 2000);
    },
    deleteFeedbackIsSpam: function(feedbackID) {
      apiServiceFeedback.deleteFeedbackIsSpam(feedbackID).then(data => {});
      this.hide();
      setTimeout(() => {
        this.reloadFeedback();
      }, 2000);
    },
    deleteFeedbackAlert: function(feedbackID) {
      this.show(feedbackID);
    },
    deleteFeedbackIsSpamAlert: function(feedbackID) {
      this.showSpamDialog(feedbackID);
    },
    show: function(feedbackID) {
      this.$modal.show("dialog", {
        title: "Alert!",
        text: "Do you want to delete this Feedback?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.deleteFeedback(feedbackID);
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: "No"
          }
        ]
      });
    },
    showSpamDialog: function(feedbackID) {
      this.$modal.show("dialog", {
        title: "Alert!",
        text: "Do you want to mark this feedback as Spammity Spam?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.deleteFeedbackIsSpam(feedbackID);
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: "No"
          }
        ]
      });
    },
    hide: function() {
      this.$modal.hide("dialog");
    },
    sentiment: function(mcss) {
      if (mcss <= -11) {
        return "Negative";
      } else if (mcss > -11 && mcss <= 49) {
        return "Neutral";
      } else {
        return "Positive";
      }
    },
    resetData: function() {
      this.npsDatas = {};
      this.npsCategories = [];
      this.actions = [];
      this.page = 1;
      this.per_page = 25;
      this.total_items = 0;
      this.total_pages = 0;
      this.numberOfCategoriesToShow = 18;
      this.property_id = this.$route.params.id;
    },
    getSentimentClass(score) {
      var sentimentColor = "";
      if (score <= -11 && score >= -100) {
        sentimentColor = "negative-color";
      } else if (score > -11 && score <= 49) {
        sentimentColor = "neutral-color";
      } else if (score > 49 && score <= 100) {
        sentimentColor = "positive-color";
      } else {
        sentimentColor = "empty-color";
      }
      return sentimentColor;
    },
    getSentimentFontColorClass(score) {
      var sentimentColor = "";
      if (score <= -11 && score >= -100) {
        sentimentColor = "negative-color-font";
      } else if (score > -11 && score <= 49) {
        sentimentColor = "neutral-color-font";
      } else if (score > 49 && score <= 100) {
        sentimentColor = "positive-color-font";
      } else {
        sentimentColor = "empty-color-font";
      }
      return sentimentColor;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Merienda");
.mj-daterange-picker {
}
h1 {
  font-size: 30px;
}
h2 {
  font-size: 22px;
}
#feedback {
  margin: 0 0;
}
.dashboard-body {
  lost-utility: clearfix;
  background: #fafafa;
}
.dashboard-box-horizontal {
  lost-column: 1/5;
  height: 236px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding: 8px 0;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #cfd1d3;
}
.three-rows {
  padding: 52px 0;
}
.dashboard-box-horizontal .box-header {
  font-size: 21px;
  display: block;
}
.action-boxes .box-header-small-line {
  font-size: 20px;
  font-weight: bold;
  padding: 0px;
  float: left;
}
.action-boxes .dashboard-centered-box {
  height: 170px;
  padding: 4px 6px 0 6px;
}
.action-box {
  lost-column: 1/2;
  background-color: #fadada;
  height: 300px;
  vertical-align: middle;
  line-height: 30px;
  padding: 10px 5px 5px 5px;
  margin-bottom: 10px;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  position: relative;
}
.action-box .box-footer {
  font-size: 14px;
  display: block;
  padding: 0 10px 5px 20px;
  text-align: right;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.action-body {
  float: left;
  width: 80%;
  clear: none;
  lost-utility: clearfix;
}
.action-body .box-header-small-line {
  display: block;
  width: 100%;
  margin-bottom: 2px;
  padding: 0;
}
.number-box-left {
  padding: 3px 10px 0 5px;
  width: 40px;
  height: 100px;
  float: left;
  clear: none;
}
.action-ngrams-box a {
  margin: 0;
  display: block;
  line-height: 19px;
}
.action-ngrams-body {
  padding-top: 10px;
}
.action-ngrams-box {
  width: 100%;
  padding-top: 5px;
  font-size: 20px;
}
.action-title {
  font-size: 20px;
}
.big-digits-number-red {
  font-size: 32px;
  font-weight: bold;
  color: #c03131;
}
.big-digits-number-black {
  font-size: 32px;
  font-weight: bold;
}
.emoji-box-right {
  padding: 3px 38px 0 5px;
  width: 40px;
  float: right;
  clear: none;
}
.sentiment-icons img {
  width: 30px;
  position: absolute;
  float: right;
  top: 10px;
  right: 7px;
}
.emoji-icons img {
  width: 30px;
  position: absolute;
  float: right;
}
.dashboard-centered-box {
  lost-column: 1/3;
  height: 122px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding-top: 6px;
  margin-bottom: 10px;
  border-radius: 4px;
}
.dashboard-centered-box .box-header {
  font-size: 21px;
  display: block;
}
.dashboard-centered-box .box-number {
  font-size: 26px;
}
.dashboard-centered-box .box-footer {
  font-size: 14px;
  display: block;
}
.category-body {
  display: block;
  width: 90%;
  margin-bottom: 16px;
  margin-left: 15px;
}
.box-header-small-line {
  font-size: 16px;
  display: block;
  line-height: normal;
  padding: 4px;
}
.dashboard-graph-line {
  lost-column: 2/3;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  padding-top: 14px;
  border-radius: 4px;
  height: 410px;
}
.dashboard-graph-doughnut {
  lost-column: 1/3;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border: 1px solid #cfe1f6;
  padding-top: 14px;
  border-radius: 4px;
  height: 410px;
  max-height: 410px;
}
.pie-chart {
  padding: 5px;
  max-width: 410px;
  margin: 0 auto;
}
.pagination {
  float: right;
  margin-bottom: 10px;
}
.positive-color {
  background-color: #33a878;
}
.negative-color {
  background-color: #df6358;
}
.neutral-color {
  background-color: #e7e5e0;
}
.empty-color {
  background-color: #e4e3e1;
}
.positive-color-font a {
  color: #33a878;
}
.negative-color-font a {
  color: #df6358;
}
.neutral-color-font a {
  color: #929292;
}
.empty-color-font a {
  color: #e4e3e1;
}
.box-link a {
  font-weight: bold;
}
/* unvisited link */
.box-link a:link {
  color: #2c3e50;
}
/* visited link */
.box-link a:visited {
  color: #2c3e50;
}
/* mouse over link */
.box-link a:hover {
  color: #2c3e50;
}
/* selected link */
.box-link a:active {
  color: #2c3e50;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}
/* Animation */
@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

td,
th {
  padding: 2px;
  background-color: #fff;
}

td.today {
  font-weight: 700;
}

td.disabled {
  pointer-events: none;
  background-color: #eee;
  border-radius: 0;
  opacity: 0.6;
}

.fa {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: transparent no-repeat 50%;
  background-size: 100% 100%;
  fill: #ccc;
}

.next:hover,
.prev:hover {
  background-color: transparent !important;
}

.next .fa:hover,
.prev .fa:hover {
  opacity: 0.6;
}

.chevron-left {
  width: 16px;
  height: 16px;
  display: block;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-2 -2 10 10'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
}

.chevron-right {
  width: 16px;
  height: 16px;
  display: block;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-2 -2 10 10'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
}

.yearselect {
  padding-right: 1px;
  border: none;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  appearance: menulist;
}

.monthselect {
  border: none;
}

.drp-calendar .col .left {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}

.daterangepicker.hide-calendars.show-ranges .ranges,
.daterangepicker.hide-calendars.show-ranges .ranges ul {
  width: 100%;
}

.daterangepicker .calendars-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.daterangepicker[readonly] {
  pointer-events: none;
}

.daterangepicker {
  position: absolute;
  color: inherit;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ddd;
  width: 278px;
  max-width: none;
  padding: 0;
  margin-top: 7px;
  top: 100px;
  left: 20px;
  z-index: 3001;
  display: none;
  font-size: 15px;
  line-height: 1em;
}

.daterangepicker:after,
.daterangepicker:before {
  position: absolute;
  display: inline-block;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: "";
}

.daterangepicker:before {
  top: -7px;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #ccc;
}

.daterangepicker:after {
  top: -6px;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  border-left: 6px solid transparent;
}

.daterangepicker.opensleft:before {
  right: 9px;
}

.daterangepicker.opensleft:after {
  right: 10px;
}

.daterangepicker.openscenter:after,
.daterangepicker.openscenter:before {
  left: 0;
  right: 0;
  width: 0;
  margin-left: auto;
  margin-right: auto;
}

.daterangepicker.opensright:before {
  left: 9px;
}

.daterangepicker.opensright:after {
  left: 10px;
}

.daterangepicker.drop-up {
  margin-top: -7px;
}

.daterangepicker.drop-up:before {
  top: auto;
  bottom: -7px;
  border-bottom: initial;
  border-top: 7px solid #ccc;
}

.daterangepicker.drop-up:after {
  top: auto;
  bottom: -6px;
  border-bottom: initial;
  border-top: 6px solid #fff;
}

.daterangepicker.single .drp-selected {
  display: none;
}

.daterangepicker.show-calendar .drp-buttons,
.daterangepicker.show-calendar .drp-calendar {
  display: block;
}

.daterangepicker.auto-apply .drp-buttons {
  display: none;
}

.daterangepicker .drp-calendar {
  display: none;
  max-width: 270px;
  width: 270px;
}

.daterangepicker .drp-calendar.left {
  padding: 8px 0 8px 8px;
}

.daterangepicker .drp-calendar.right {
  padding: 8px;
}

.daterangepicker .drp-calendar.single .calendar-table {
  border: none;
}

.daterangepicker .calendar-table .next span,
.daterangepicker .calendar-table .prev span {
  color: #fff;
  border: solid #000;
  border-width: 0 2px 2px 0;
  border-radius: 0;
  display: inline-block;
  padding: 3px;
}

.daterangepicker .calendar-table .next span {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.daterangepicker .calendar-table .prev span {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.daterangepicker .calendar-table td,
.daterangepicker .calendar-table th {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
  min-width: 32px;
  width: 32px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
}

.daterangepicker .calendar-table {
  border: 1px solid #fff;
  border-radius: 4px;
  background-color: #fff;
}

.daterangepicker .calendar-table table {
  width: 100%;
  margin: 0;
  border-spacing: 0;
  border-collapse: collapse;
  display: table;
}

.daterangepicker td.available:hover,
.daterangepicker th.available:hover {
  background-color: #eee;
  border-color: transparent;
  color: inherit;
}

.daterangepicker td.week,
.daterangepicker th.week {
  font-size: 80%;
  color: #ccc;
}

.daterangepicker td.off,
.daterangepicker td.off.end-date,
.daterangepicker td.off.in-range,
.daterangepicker td.off.start-date {
  background-color: #fff;
  border-color: transparent;
  color: #999;
}

.daterangepicker td.in-range {
  background-color: #ebf4f8;
  border-color: transparent;
  color: #000;
  border-radius: 0;
}

.daterangepicker td.start-date {
  border-radius: 4px 0 0 4px;
}

.daterangepicker td.end-date {
  border-radius: 0 4px 4px 0;
}

.daterangepicker td.start-date.end-date {
  border-radius: 4px;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #357ebd;
  border-color: transparent;
  color: #fff;
}

.daterangepicker th.month {
  width: auto;
}

.daterangepicker option.disabled,
.daterangepicker td.disabled {
  color: #999;
  cursor: not-allowed;
  text-decoration: line-through;
}

.daterangepicker select.monthselect,
.daterangepicker select.yearselect {
  font-size: 12px;
  padding: 1px;
  height: auto;
  margin: 0;
  cursor: default;
}

.daterangepicker select.monthselect {
  margin-right: 2%;
  width: 56%;
}

.daterangepicker select.yearselect {
  width: 40%;
}

.daterangepicker select.ampmselect,
.daterangepicker select.hourselect,
.daterangepicker select.minuteselect,
.daterangepicker select.secondselect {
  width: 50px;
  margin: 0 auto;
  background: #eee;
  border: 1px solid #eee;
  padding: 2px;
  outline: 0;
  font-size: 12px;
}

.daterangepicker .calendar-time {
  text-align: center;
  margin: 4px auto 0 auto;
  line-height: 30px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.daterangepicker .calendar-time select.disabled {
  color: #ccc;
  cursor: not-allowed;
}

.daterangepicker .drp-buttons {
  clear: both;
  text-align: right;
  padding: 8px;
  border-top: 1px solid #ddd;
  display: none;
  line-height: 12px;
  vertical-align: middle;
}

.daterangepicker .drp-selected {
  display: inline-block;
  font-size: 12px;
  padding-right: 8px;
}

.daterangepicker .drp-buttons .btn {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 8px;
}

.daterangepicker.show-ranges .drp-calendar.left {
  border-left: 1px solid #ddd;
}

.daterangepicker .ranges {
  text-align: left;
  margin: 0;
}

.daterangepicker.show-calendar .ranges {
  margin-top: 8px;
}

.daterangepicker .ranges ul {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}

.daterangepicker .ranges li {
  font-size: 12px;
  padding: 8px 12px;
  cursor: pointer;
}

.daterangepicker .ranges li:hover {
  background-color: #eee;
  color: #000;
}

.daterangepicker .ranges li.active {
  background-color: #08c;
  color: #fff;
}

@media (min-width: 564px) {
  .daterangepicker {
    width: auto;
  }
  .daterangepicker .ranges ul {
    width: 140px;
  }
  .daterangepicker.single .ranges ul {
    width: 100%;
  }
  .daterangepicker.single .drp-calendar.left {
    clear: none;
  }
  .daterangepicker.ltr {
    direction: ltr;
    text-align: left;
  }
  .daterangepicker.ltr .drp-calendar.left {
    clear: left;
    margin-right: 0;
  }
  .daterangepicker.ltr .drp-calendar.left .calendar-table {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .daterangepicker.ltr .drp-calendar.right {
    margin-left: 0;
  }
  .daterangepicker.ltr .drp-calendar.right .calendar-table {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .daterangepicker.ltr .drp-calendar.left .calendar-table {
    padding-right: 8px;
  }
  .daterangepicker.rtl {
    direction: rtl;
    text-align: right;
  }
  .daterangepicker.rtl .drp-calendar.left {
    clear: right;
    margin-left: 0;
  }
  .daterangepicker.rtl .drp-calendar.left .calendar-table {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .daterangepicker.rtl .drp-calendar.right {
    margin-right: 0;
  }
  .daterangepicker.rtl .drp-calendar.right .calendar-table {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .daterangepicker.rtl .drp-calendar.left .calendar-table {
    padding-left: 12px;
  }
  .daterangepicker.rtl .drp-calendar,
  .daterangepicker.rtl .ranges {
    text-align: right;
  }
}

@media (max-width: 1070px) {
  .action-body .box-header-small-line {
    font-size: 18px;
  }
  .category-body {
    margin-left: 0px;
  }
}
@media (max-width: 1019px) {
  .dashboard-centered-box {
    lost-column: 1/2;
  }
  .dashboard-box-horizontal .box-header {
    font-size: 16px;
  }
  .category-body {
    margin-left: 5px;
  }
}
@media (max-width: 950px) {
  .action-box {
    lost-column: 1/1;
    height: 280px;
  }
  .dashboard-box-horizontal {
    lost-column: 1/3;
  }
}
@media (max-width: 770px) {
  .dashboard-centered-box {
    margin-bottom: 10px;
    height: 148px;
  }
  .dashboard-box-horizontal {
    lost-column: 1/2;
  }
}
@media (max-width: 663px) {
  .dashboard-centered-box {
    lost-column: 1/1;
  }
  .dashboard-graph-line {
    lost-column: 1/1;
  }
  .dashboard-graph-doughnut {
    lost-column: 1/1;
    lost-utility: clearfix;
  }
}
@media (max-width: 570px) {
  .dashboard-box-horizontal {
    lost-column: 1/1;
  }
  .action-box {
    lost-column: 1/1;
    height: 280px;
    padding: 6px;
    margin: 6px;
  }
}
@media (max-width: 499px) {
  .full-box {
    lost-utility: clearfix;
  }
  h1 {
    font-size: 20px;
  }
}
</style>
